import {getParentId} from "~/stateGetter";
import {fetchTableResults} from "~/rx/model/tableResults";
import {fetchItem} from "~/rx/model/fetchItem";

export default async function preloadClose(dispatch, state, modelId) {
    let parentModelId = getParentId(state, modelId);
    if(parentModelId) {
        await dispatch(fetchItem(parentModelId));
    } else {
        await dispatch(fetchTableResults(modelId));
    }
}